import React from 'react';
import { take } from 'lodash';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';

import { PATH } from '../../../constants/path';
import { CONTEXT_ROOT } from '../../../constants';

import mea from '../../../services/mea';

import HeadComponent from '../../HeadComponent';
import { withTemplate } from '../../template/withTemplate';
import CarouselComponent from '../../carousel/CarouselComponent';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';
import PartnerBlockComponent from '../../partner/PartnerBlockComponent';
import ItemCarrouselComponent from '../../carousel/ItemCarrouselComponent';
import LocalizedBreadcrumbItem from '../../breadcrumb/LocalizedBreadcrumbsItem';

import './BestOffersPage.scss';

const carouselOptions = {
    dots: false,
    infinite: true,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1
};

export class BestOffersPage extends React.Component {
    componentDidMount() {
        this.props.fetchMeasIfNeeded(mea.constants.ONLINE_OFFER);
        this.props.fetchMeasIfNeeded(mea.constants.OFFLINE_OFFER);
        this.props.fetchMeasIfNeeded(mea.constants.EBON_OFFER);
    }
    renderOnlineOffers = () => {
        const { i18nPage, partners, onlineOffers } = this.props;

        if (partners && onlineOffers && onlineOffers.length > 0) {
            return (
                <MediaQuery query="(max-width: 768px)">
                    {matches =>
                        matches ? (
                            <React.Fragment>
                                <div className="conteneur-mobile">
                                    <h2>{i18nPage.ONLINE_OFFERS_SELECTION_TITLE}</h2>
                                </div>
                                <section className="offer-carousel">
                                    <CarouselComponent options={carouselOptions}>
                                        {onlineOffers
                                            .filter(p => partners[p.idPartenaire])
                                            .sort((a, b) => a.ordreAffichage - b.ordreAffichage)
                                            .map((item, i) => {
                                                return (
                                                    <ItemCarrouselComponent
                                                        item={item}
                                                        key={i}
                                                        partner={
                                                            partners[item.idPartenaire]
                                                                ? partners[item.idPartenaire]
                                                                : null
                                                        }
                                                        noPicture
                                                    />
                                                );
                                            })}
                                    </CarouselComponent>
                                </section>
                            </React.Fragment>
                        ) : (
                            <section className="selection-mois">
                                <h2>{i18nPage.ONLINE_OFFERS_SELECTION_TITLE}</h2>
                                <div className="grid-4-small-2 has-gutter">
                                    {take(
                                        onlineOffers
                                            .filter(p => partners[p.idPartenaire])
                                            .sort((a, b) => a.ordreAffichage - b.ordreAffichage),
                                        4
                                    ).map((item, i) => {
                                        return (
                                            <PartnerBlockComponent
                                                partner={
                                                    partners[item.idPartenaire]
                                                        ? partners[item.idPartenaire]
                                                        : null
                                                }
                                                key={i}
                                            />
                                        );
                                    })}
                                </div>
                            </section>
                        )
                    }
                </MediaQuery>
            );
        }
    };
    renderOfflineOffers = () => {
        const { i18nPage, partners, offlineOffers } = this.props;

        if (partners && offlineOffers && offlineOffers.length > 0) {
            return (
                <MediaQuery query="(max-width: 768px)">
                    {matches =>
                        matches ? (
                            <React.Fragment>
                                <div className="conteneur-mobile">
                                    <h2>{i18nPage.OFFLINE_OFFERS_SELECTION_TITLE}</h2>
                                </div>
                                <section className="offer-carousel">
                                    <CarouselComponent options={carouselOptions}>
                                        {offlineOffers
                                            .filter(p => partners[p.idPartenaire])
                                            .sort((a, b) => a.ordreAffichage - b.ordreAffichage)
                                            .map((item, i) => {
                                                return (
                                                    <ItemCarrouselComponent
                                                        item={item}
                                                        key={i}
                                                        partner={
                                                            partners[item.idPartenaire]
                                                                ? partners[item.idPartenaire]
                                                                : null
                                                        }
                                                        noPicture
                                                        isOffline
                                                    />
                                                );
                                            })}
                                    </CarouselComponent>
                                </section>
                            </React.Fragment>
                        ) : (
                            <section className="selection-mois">
                                <h2>{i18nPage.OFFLINE_OFFERS_SELECTION_TITLE}</h2>
                                <div className="grid-4-small-2 has-gutter">
                                    {take(
                                        offlineOffers
                                            .filter(p => partners[p.idPartenaire])
                                            .sort((a, b) => a.ordreAffichage - b.ordreAffichage),
                                        4
                                    ).map((item, i) => {
                                        return (
                                            <PartnerBlockComponent
                                                partner={
                                                    partners[item.idPartenaire]
                                                        ? partners[item.idPartenaire]
                                                        : null
                                                }
                                                key={i}
                                                isOffline={true}
                                            />
                                        );
                                    })}
                                </div>
                            </section>
                        )
                    }
                </MediaQuery>
            );
        }
    };
    renderEbonOffers = () => {
        const { i18nPage, ebonPartners, ebonOffers } = this.props;

        if (ebonPartners && ebonOffers && ebonOffers.length > 0) {
            return (
                <MediaQuery query="(max-width: 768px)">
                    {matches =>
                        matches ? (
                            <React.Fragment>
                                <div className="conteneur-mobile">
                                    <h2>{i18nPage.EBON_OFFERS_SELECTION_TITLE}</h2>
                                </div>
                                <section className="offer-carousel">
                                    <CarouselComponent options={carouselOptions}>
                                        {ebonOffers
                                            .filter(mea =>
                                                ebonPartners.filter(p => mea.idPartenaire === p.id)
                                            )
                                            .sort((a, b) => a.ordreAffichage - b.ordreAffichage)
                                            .map((item, i) => {
                                                return (
                                                    <ItemCarrouselComponent
                                                        item={item}
                                                        key={i}
                                                        partner={
                                                            ebonPartners.find(
                                                                p => item.idPartenaire === p.id
                                                            )
                                                                ? ebonPartners.find(
                                                                      p =>
                                                                          item.idPartenaire === p.id
                                                                  )
                                                                : null
                                                        }
                                                        noPicture
                                                        isEbon
                                                    />
                                                );
                                            })}
                                    </CarouselComponent>
                                </section>
                            </React.Fragment>
                        ) : (
                            <section className="selection-mois">
                                <h2>{i18nPage.EBON_OFFERS_SELECTION_TITLE}</h2>
                                <div className="grid-4-small-2 has-gutter">
                                    {take(
                                        ebonOffers
                                            .filter(mea =>
                                                ebonPartners.filter(p => mea.idPartenaire === p.id)
                                            )
                                            .sort((a, b) => a.ordreAffichage - b.ordreAffichage),
                                        4
                                    ).map((item, i) => {
                                        return (
                                            <PartnerBlockComponent
                                                partner={
                                                    ebonPartners.find(
                                                        p => item.idPartenaire === p.id
                                                    )
                                                        ? ebonPartners.find(
                                                              p => item.idPartenaire === p.id
                                                          )
                                                        : null
                                                }
                                                key={i}
                                                isEbon
                                            />
                                        );
                                    })}
                                </div>
                            </section>
                        )
                    }
                </MediaQuery>
            );
        }
    };

    render() {
        const { i18nPage } = this.props;

        return (
            <React.Fragment>
                <main className="conteneur" id="p-best-offer">
                    <HeadComponent
                        title={i18nPage.TITLE}
                        description={i18nPage.DESCRIPTION}
                        canonicalLink={`${CONTEXT_ROOT}${PATH.HOW_IT_WORK_PATH}`}
                    />
                    <LocalizedBreadcrumbItem to={PATH.HOW_IT_WORK_PATH}>
                        {i18nPage.BREADCRUMB}
                    </LocalizedBreadcrumbItem>
                    <h1 className="conteneur-mobile">{i18nPage.TITLE}</h1>

                    {this.renderOnlineOffers()}
                    {this.renderOfflineOffers()}
                    {this.renderEbonOffers()}
                </main>
            </React.Fragment>
        );
    }
}

// Which props do we want to inject, given the global state?
const mapStateToProps = state => {
    return {
        i18nPage: state.i18n.page.BEST_OFFERS,
        onlineOffers: mea.selectors.getMeasListByTypeId(state, mea.constants.ONLINE_OFFER),
        offlineOffers: mea.selectors.getMeasListByTypeId(state, mea.constants.OFFLINE_OFFER),
        ebonOffers: mea.selectors.getMeasListByTypeId(state, mea.constants.EBON_OFFER),
        partners: state.partner.partners,
        ebonPartners: state.ebon.ebonPartners
    };
};

const mapDispatchToProps = {
    fetchMeasIfNeeded: mea.actions.fetchMeasIfNeeded
};

export default withTemplate(
    connect(mapStateToProps, mapDispatchToProps)(BestOffersPage),
    PrimaryTemplate
);



// WEBPACK FOOTER //
// ./src/components/pages/bestoffers/BestOffersPage.js